import { useContext } from 'react';
import { DashboardGroupsComponent } from './styles/DashboardGroupsComponent';
import { GuestDashboardContext } from './guestDashboardContext';
import moment from 'moment';
import { weekdays } from '../../components/helpers';
import { getGroupLeaders } from '../groups/registration/leaderSelect';

const Groups = () => {
  const { guestGroup, guestGroups, guest } = useContext(GuestDashboardContext);

  const groupMembersGroup = guestGroup?.groupMembers;
  return (
    <DashboardGroupsComponent>
      <div className="groups-header">
        <h3 className="groups-heading-top">Estos son tus</h3>
        <h2 className="groups-heading-main">Grupos</h2>
      </div>
      <div className="groups-scroll">
        <div className="columnsGroup">
          <div className="columnGroup">
            <div className="container-group">
              <p className="groups-section-label">Haces parte del grupo</p>
              {!!groupMembersGroup?.length ? (
                groupMembersGroup?.map((group, index) => (
                  <div
                    className={`container-group-in ${group.pending ? 'pending' : ''}`}
                    key={index}
                  >
                    {group.pending && <div className="pending-banner">Pendiente de aprobación</div>}
                    <p className="group-card-title">{group?.ChurchGroup?.groupName}</p>
                    <p className="group-card-leaders">{getGroupLeaders(group?.ChurchGroup)}</p>
                    <div className="group-meta-row">
                      <div className="group-meta-cell">
                        <p className="subtitle">Modalidad</p>
                        <p className="group-meta-value">
                          {group?.ChurchGroup?.online ? 'Virtual' : 'Presencial'}
                        </p>
                      </div>
                      <div className="group-meta-cell">
                        <p className="subtitle">Horario</p>
                        <p className="group-meta-value">
                          {weekdays[group?.ChurchGroup?.dayOfWeek]}
                          {', '}
                          {moment(group?.ChurchGroup?.time, 'HH:mm').format('hh:mm a')}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>
                  No haces parte de ningún grupo,{' '}
                  <a
                    className="link"
                    href="https://www.comunidadmde.com/grupos"
                    target="_blank"
                    rel="noreferrer"
                  >
                    haz clic aquí para comenzar a hacer parte de una Comunidad.
                  </a>
                </p>
              )}
              <p className="groups-section-label groups-section-label--spaced">
                Estos son tus grupos.
              </p>
              <div className="your-group">
                {!!guestGroups?.length ? (
                  guestGroups?.map?.((group, index) => (
                    <button
                      key={index}
                      className="group-button"
                      onClick={() =>
                        window.open(
                          `/grupos/lider?phone=${guest?.phone}&identification=${guest?.identification}&activityName=${group.activityName}&kindgroup=${group.kind}`,
                          '_blank'
                        )
                      }
                    >
                      {group.groupName}
                      <p>{group.activityName.replace(/_/g, ' ')}</p>
                    </button>
                  ))
                ) : (
                  <p>
                    No estás liderando un grupo en este momento
                    {!!groupMembersGroup?.length && (
                      <a
                        href="https://www.comunidadmde.com/grupos"
                        target="_blank"
                        rel="noreferrer"
                      >
                        , haz clic aquí para comenzar a liderar en Comunidad.
                      </a>
                    )}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardGroupsComponent>
  );
};

export default Groups;
